<template>

    <b-modal :title="title" size="huge" id="2" class="p-0 m-0 clearfix" v-model="dialogOpen" @hidden="onDialogHidden" ok-only ok-variant="secondary" ok-title="Close">

        <template #modal-header="" class="mb-0 pb-0">
            <div class="float-left">
                <h5 class="mb-0 pb-0">{{ title }} [{{ totalRows }}]</h5>
                <span v-if="timeZoneId != null" class="m-0 p-0"><strong>Time Zone:</strong> {{ timeZoneId }} </span>
                <span class="m-0 mr-1 p-0"><strong>Date:</strong> {{ formatDateTime(relevantDate, 'DD-MMM-YYYY') }}</span>

                <div class="mt-1">
                    <b-form-checkbox size="sm" v-model="includeUnavailableStaff" @change="loadAvailableStaff()" class="float-left mr-3">include unavailable staff</b-form-checkbox>
                    <b-form-checkbox size="sm" v-model="filterNoAssignedJobsOnly" class="float-left">only show staff with no Jobs assigned</b-form-checkbox>
                </div>
            </div>
            <div class="float-right">
                <div>
                    <b-form-checkbox-group class="float-right" v-model="filterIncludeRoles"
                                           :options="filterRoleOptions">
                    </b-form-checkbox-group>
                </div>
            </div>
        </template>

        <div class="w-100">
            <div class="float-left mr-2"><strong>Employment Type:</strong> {{ employmentType!=null ? employmentType : 'all' }}</div>
            <div class="float-left mr-2"><strong>Skill Level:</strong> {{ skillLevel!=null ? skillLevel : 'all' }}</div>
            <div class="float-left"><strong>Registry/Organisation:</strong> {{ entityDisplayString }}</div>
            <div class="float-right">
                <b-form-input size="sm" v-model="nameFilter" placeholder="Name filter" class="float-right mb-1" style="width: 200px;"></b-form-input>
            </div>
        </div>

        <b-table-simple class="table table-bordered" v-if="filteredAvailableStaff.length">
            <b-thead>
                <b-tr>
                    <b-th style="width:50px;" class="text-center">Clear</b-th>
                    <b-th class="w-25">Staff Name</b-th>
                    <b-th style="width: 100px;" class="text-center">Type</b-th>
                    <b-th style="width: 100px;" class="text-center">Skill</b-th>
                    <b-th style="width: 140px;" class="text-center">Roles</b-th>
                    <b-th style="width: 100px;" class="text-center" v-if="true">Minutes</b-th>
                    <b-th style="width: 100px;" class="text-center">Travel</b-th>
                    <b-th style="width: 100px;" class="text-center">On site</b-th>
                    <b-th style="width: 100px;" class="text-center">Real Time</b-th>
                </b-tr>
            </b-thead>

            <b-tbody>

                <b-tr class="smaller" v-for="(staffMember,staffMemberIndex) in filteredAvailableStaff" v-bind:key="staffMemberIndex" style="height:20px;">

                    <b-td class="bg-light text-center align-middle m-0 p-0">
                        <div v-b-tooltip.hover="staffMember.securityClearanceDisplayName">{{ abreviateSecurityClearanceDispalyName(staffMember.securityClearanceDisplayName) }}</div>
                    </b-td>

                    <b-td style="" class="bg-light align-middle" :id="`popover-1-${staffMemberIndex}`">
                        {{ staffMember.givenNames }}<strong> {{ staffMember.lastName }}</strong> [<b-link :href="$urlHelper.getPageUrl('WorkItems', [ staffMember.userAccountId, 'User' ])" target="blank">{{ staffMember.assignedJobs }}</b-link>]
                    </b-td>

                    <b-td class="m-0 p-0 text-center align-middle bg-light">
                        {{ staffMember.employmentTypeDisplayName }}
                    </b-td>

                    <b-td class="bg-light text-center align-middle">
                        <img :src="getSkillLevelImageUrl(staffMember.skillLevel)" :alt="staffMember.skillLevelDisplayName" :title="staffMember.skillLevelDisplayName" height="20" />
                    </b-td>

                    <b-td class="bg-light text-center align-middle">
                        <template v-for="role in staffMember.roles">
                            <img class="mr-2" :src="getRoleImageUrl(role.roleId)" :alt="role.roleDisplayName" :title="role.roleDisplayName" width="17" :key="role.roleId" v-if="isRoleRelevant(role.roleId)" />
                        </template>
                    </b-td>

                    <b-td class="m-0 p-0 text-center align-middle">
                        <span v-if="checkIfApplicable(64)">n/a</span><span v-else>{{ staffMember.days[0].audioMinutes }}</span>
                    </b-td>

                    <b-td class="m-0 p-0 text-center align-middle">
                        <span v-if="checkIfApplicable(32)">n/a</span>
                        <span v-else>
                            <b-icon v-if="staffMember.availableForTravel" class="h4 mt-2" icon="check-square" variant="success"></b-icon>
                            <b-icon v-else icon="x-square" class="h4 mt-2" variant="danger"></b-icon>
                        </span>
                    </b-td>

                    <b-td class="m-0 p-0 text-center align-middle">
                        <span v-if="checkIfApplicable(32)">n/a</span>
                        <span v-else>
                            <b-icon v-if="staffMember.availableForOnSite" class="h4 mt-2" icon="check-square" variant="success"></b-icon>
                            <b-icon v-else icon="x-square" class="h4 mt-2" variant="danger"></b-icon>
                        </span>
                    </b-td>

                    <b-td class="m-0 p-0 text-center align-middle">
                        <span v-if="checkIfApplicable(32)">n/a</span>
                        <span v-else>
                            <b-icon v-if="staffMember.availableForRealTime" class="h4 mt-2" icon="check-square" variant="success"></b-icon>
                            <b-icon v-else icon="x-square" class="h4 mt-2" variant="danger"></b-icon>
                        </span>
                    </b-td>

                    <b-popover :target="`popover-1-${staffMemberIndex}`"
                               placement="right"
                               :title="'Profile: ' + staffMember.givenNames + ' ' + staffMember.lastName"
                               triggers="hover"
                               custom-class="wide-popover"
                               variant="dark">

                        <b-card custom-class="w-25">
                            <b-card-text>
                                <b-container class="bv-example-row">
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Name:</b-col>
                                        <b-col>{{ staffMember.givenNames }} {{ staffMember.lastName }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Employment Type:</b-col>
                                        <b-col>{{ staffMember.employmentTypeDisplayName }}</b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Skill level:</b-col>
                                        <b-col>{{ staffMember.skillLevelDisplayName }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Security Clearance:</b-col>
                                        <b-col>{{ staffMember.securityClearanceDisplayName }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Roles:</b-col>
                                        <b-col>
                                            <div v-html="createRoleDisplayString(staffMember.roles)"></div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Assigned Jobs:</b-col>
                                        <b-col>{{ staffMember.assignedJobs }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Delayed Audio Minutes:</b-col>
                                        <b-col>{{ staffMember.days[0].audioMinutes }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Options:</b-col>
                                        <b-col>
                                            <div v-html="createOptionsDisplayString(staffMember)"></div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6" class="font-weight-bold">Comments:</b-col>
                                        <b-col>{{ staffMember.comments }}</b-col>
                                    </b-row>
                                </b-container>
                            </b-card-text>
                        </b-card>
                    </b-popover>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <template #modal-footer>
            <div class="w-100 mb-2 p-0">
                <b-pagination v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              aria-controls="my-table"
                              class="float-left m-0 p-0"></b-pagination>

                <b-select v-model="perPage" :options="pageSizes" class=" ml-2 float-left w-auto" />
                <b-badge class="ml-2 mt-2 p-2" variant="primary">Total available staff: {{ totalRows }}</b-badge>
                <b-button @click="dialogOpen=false;" variant="secondary" class="float-right mr-1">Close</b-button>
            </div>
        </template>
        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Loading..." v-if="showSpinner"></b-spinner>
        </div>
    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UserMixin from '../../mixins/UserMixin';

    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AvailabilityOptionsAccumulated',
        mixins: [ErrorsMixin, DateTimeMixin, UserMixin],
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {
            // availability controller URL
            apiControllerUrl: { 
                type: String,
                required: true
            },
            imagesUrl: {
                type: String,
                required: true
            },
            title: {
                type: String,
                default: 'no title'
            },
            relevantRoles: {
                type: Array,
                required: true
            },
            checkedRoles: {
                type: Array,
                default: null
            },
            relevantDate: {
                type: Date,
                required: false,
                default: function () { // FRAGE
                    return new Date()
                },
            },
            active: {
                type: Boolean,
                default: false
            },
            // filter related stuff start
            timeRangeFilter: {
                type: String,
                required: false,
                default: null
            },
            employmentType: {
                type: String,
                required: false,
                default: null
            },
            skillLevel: {
                type: String,
                required: false,
                default: null
            },
            courtRegistryId: {
                type: String,
                required: false,
                default: null
            },
            interviewOrganisationId: {
                type: String,
                default: null
            },
            entityDisplayString: {
                type: String,
                required: false,
                default: null
            },
            timeZoneId: {
                type: String,
                required: false,
                default: null
            },
            onlyCheckOptions: {
                type: Boolean,
                required: true
            }
        },
        data: function () {
            return {
                showSpinner: false,
                dialogOpen: this.active,
                availableStaff: null,
                filterIncludeRoles: Array.from(this.relevantRoles, role => role.roleId), //this will "convert" the array of objects into an array of role IDs
                // paging vars
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
                pageSizes: [5, 10, 25, 50],
                nameFilter: '',
                filterNoAssignedJobsOnly: false,
                currentSelectedStaff: null,
                includeUnavailableStaff: false
            }
        },

        watch: {
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.loadAvailableStaff(true);
                }
            },
            checkedRoles: function () {
                if (this.checkedRoles != null) {
                    this.filterIncludeRoles = this.checkedRoles;
                } else {
                    this.filterIncludeRoles = Array.from(this.relevantRoles, role => role.roleId);
                }
            }
        },

        computed: {

            filterRoleOptions: function () {
                var roles = [];
                this.relevantRoles.forEach((role) => {
                    roles.push({ value: role.roleId, text: role.roleDisplayName });
                });
                return roles;
            },

            filteredAvailableStaff: function () {

                var filteredStaffList = [];
                if (this.availableStaff && this.availableStaff.length) {
                    // to make sure that THIS referes to the component inside the forEach
                    var thisComponent = this;    
                    this.availableStaff.forEach(function (staffMember) {

                        var include = false;
                        var assignedRoles = staffMember.roles;

                        for (var i = 0; i < assignedRoles.length; i++) {
                            var roleId = assignedRoles[i].roleId;
                            if (thisComponent.filterIncludeRoles && (thisComponent.filterIncludeRoles.indexOf(roleId) >= 0)) include = true;
                        }
                        if (include && thisComponent.filterNoAssignedJobsOnly) {
                            if (staffMember.assignedJobs > 0) include = false;
                        }

                        var nameInclude = true;
                        if (thisComponent.nameFilter != '') {
                            if (staffMember.givenNames.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0 &&
                                staffMember.lastName.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0) { nameInclude = false; }
                        }

                        if (include && nameInclude) { filteredStaffList.push(staffMember); }
                    });
                }
                // setting the total number of Filterd rows (checkboxes!) before we slice for paging
                this.setTotalRowsForDisplay(filteredStaffList.length);
                // slicing the filtered result for paging
                return filteredStaffList.slice((this.currentPage - 1) * this.perPage, (this.currentPage - 1) * this.perPage + this.perPage);
            }
        }, // computed

        methods: {

            checkIfApplicable: function (roleId) {
                if (this.filterIncludeRoles.length == 1 && this.filterIncludeRoles[0] == roleId) return true;
                else return false;
            },

            abreviateSecurityClearanceDispalyName: function (securityDisplayName) {
                var wordArray = securityDisplayName.split(" ");
                var abreviatedDisplayString = '';
      
                for (var i = 0; i < wordArray.length; i++) {
                    abreviatedDisplayString += wordArray[i].charAt(0)
                }
                return abreviatedDisplayString;
            },

            isRoleRelevant(roleId) {
                return this.relevantRoles.find(role => role.roleId == roleId);
            },

            setTotalRowsForDisplay: function (numberOfFilteredRows) {
                this.totalRows = numberOfFilteredRows;
            },
            createRoleDisplayString: function (roleArray) {
                var roleDisplayString = '';
                for (var i = 0; i < roleArray.length; i++) {
                    roleDisplayString += roleArray[i].roleDisplayName + '<br />';
                }
                return roleDisplayString;
            },
            createOptionsDisplayString: function (staffMember) {
                var optionsDisplayString = '';
                if (staffMember.availableForRealTime) optionsDisplayString = 'TVL';
                if (staffMember.availableForOnSite) optionsDisplayString += ' O/S';
                if (staffMember.availableForTravel) optionsDisplayString += ' RT';
                return optionsDisplayString;
            },

            loadAvailableStaff: function (openDialog = false) {

                this.showSpinner = true;
                var requiredRoles = 0;
                this.relevantRoles.forEach(role => {
                    requiredRoles += role.roleId;
                });

                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';

                var filters = {
                    timeRange: 1, // this is default for giving back all 24 hours worth
                    typistSkillLevel: this.skillLevel,
                    employmentType: this.employmentType,
                    courtRegistryId: this.courtRegistryId,
                    interviewOrganisationId: this.interviewOrganisationId,
                    timezoneId: this.timeZoneId,
                    // default: sorted: [{ name: "staffName", direction: "descending" }],
                    sorted: [{ name: this.columnToSort, direction: this.sortDirection }],
                    requiredRoles: requiredRoles,
                    includeUnavailableStaff: this.includeUnavailableStaff,
                    onlyCheckOptions: this.onlyCheckOptions
                }

                url += 'stafflistfordelayedworkforday/';
                url += this.formatDateTime(this.relevantDate, 'YYYY-MM-DD', true, true)
                axios
                    .post(url, JSON.stringify(filters),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.availableStaff = response.data;
                        this.showSpinner = false;
                        if (openDialog) this.dialogOpen = true;
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
           
            onDialogHidden: function () {
                this.$emit('change', false);
            }
        }, // methods 

        mounted: function () {

            if (this.checkedRoles != null) {
                this.filterIncludeRoles = this.checkedRoles;
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 992px) {
        div >>> .modal .modal-huge {
            width: 95% !important;
            max-width: 1400px !important;
        }
    }
    div >>> .wide-popover {
        max-width: 500px !important;
        width: 500px !important;
    }
    div >>> .available {
        background-color: green !important;
    }
    div >>> .not-available {
        background-color: #aaa !important;
    }
</style>
